import { LinkButton } from '@shared/ui/button';
import { Breadcrumbs } from '@shared/ui/breadcrumbs';
import { PageTitle } from '@shared/ui/titles';
import { PageContainer } from '@shared/ui/content-containers';
import { Preloader } from '@shared/ui/preloader';
import { PageBanner, PageCustomText, PageHelmet } from '@widgets/seoPage';
import ErrorPage from 'frontend/Pages/ErrorPage/ErrorPage';
import { useLoaderData, useRouteLoaderData } from '@shared/lib/routing';
import { useTranslation } from 'react-i18next';
import CardList from 'frontend/Components/Products/CardList/CardList';
import { getToppingsIdFromProducts } from '@entities/product';
import { HtmlParser } from '@shared/html';
import { onePromotionPageLoader } from '../api';

export function OnePromotionPage() {
  const { pageData, loading } =
    useLoaderData<Awaited<ReturnType<typeof onePromotionPageLoader>>>();
  const { country, city } = useRouteLoaderData('city-layout');
  const { t } = useTranslation();

  if (loading) return <Preloader />;

  const {
    seoPageData,
    onePromotionPageData: { stock: promotion },
  } = pageData;

  if (!promotion?.length) {
    return <ErrorPage action_link="/akcii" action_text={t('Stock.show_all')} />;
  }

  const { title, description, description_stock, images, pinned_products } =
    promotion[0];

  const toppings = getToppingsIdFromProducts(pinned_products);
  const filteredProducts = pinned_products?.filter(
    (product) => !toppings.includes(product.id),
  ); // чистим коллекцию от продуктов если они уже включены в суперпродукт

  return (
    <>
      <PageBanner
        bannerData={seoPageData.banner}
        mainDomain={country.main_domain}
      />
      <PageHelmet
        cityName={city.city_name}
        mainDomain={country.main_domain}
        seo={seoPageData.seo}
        type="article"
        title={title}
        image={images?.[0]?.filename}
        ogTitle={title}
        ogDescription={description_stock}
      />
      <PageContainer>
        <Breadcrumbs
          links={[
            {
              href: '/akcii',
              text: t('localization.Stocks'),
            },
            {
              text: title,
            },
          ]}
        />
        <PageTitle isCenterOnMobile>{title}</PageTitle>
        <div className="max-w-185">
          <HtmlParser
            data={description || description_stock}
            imgProps={{
              mainDomain: country.main_domain,
              alt: 'action image',
              width: 740,
              height: 490,
            }}
          />
        </div>
        {filteredProducts && (
          <CardList
            products={filteredProducts}
            notFilterPanel
            title={t('Stock.products_title')}
            position="promotion"
          />
        )}
        <div className="flex justify-center">
          <LinkButton href="/akcii">{t('Stock.show_all')}</LinkButton>
        </div>
        <PageCustomText
          customText={seoPageData.seo.custom_text}
          mainDomain={country.main_domain}
        />
      </PageContainer>
    </>
  );
}
